import xiazuanConfig from "./drillDownConfig"
import turf from "turf"
import mapboxgl from "mapbox-gl"

let that = "";

class drillDown {
  /*构造函数*/
  constructor() {

    /*地图实例*/
    /*个性化配置项,在激活下钻传参时候可配置options中的所有项目*/
    this.options = {
      init_hilight: true,/*是否初始化高亮*/
      init_hilight_qhdm: '',
      drill_down_sys_hilight_bk: "sys_hilight_layerId",
      last_click_query_features: "",/*上次下钻查询的下级features*/
      last_click_e: "",/*上次下钻点击图层返回的参数*/
      ifHlightBorder: true, /*是否高亮边框*/
      xiazuanToLevel: "", /*配置下钻的最低级别,比如村级不需要下钻,这里就配置为村的level数*/
      cyXizauanZoomLevel: 13.1, /*点击村域,下钻后的级别,如点击村域下钻后需要显示地块,则此处可设置地块的minZoom保证地块能显示,默认13.1,如传"fit",则定位以显示村范围为主*/
      cyFitMaxZoom: "",/*点击村域下钻为fit时,设置最大放大级别*/
      cyFitPadding: "",/*点击村域下钻为fit时,设置padding*/

      limit_qhdm: '',/*限制区划代码，只有在改区划及以下才有下钻效果*/

      cur_over_qhdm:'',
    };
    this.map = ''
    this.addLayerIds = [],
      this.clickCallBack = ""/*下钻点击callback,点击下钻图层后立刻执行*/
  }

  /**
   * 1.接口:
   *    active:激活下钻功能;
   *    inActive:卸载下钻功能;
   */

  /**
   * @param mapC  地图实例
   * @param optionsC  个性化配置参数
   * @param clikCallBack 下钻的点击立刻执行的回调函数
   * @returns {string}
   */
  active(mapC, optionsC = {}, eventConfigPar = {}) {
    that = this;

    if (that.map) {
      that.inActive()
    }
    ;/*激活新的下钻之前解绑上次下钻，防止二次绑定造成下钻不准*/

    if (!mapC || !mapC.getLayer) {
      console.warn("未传入地图实例,下钻初始化失败");
      return "请传入地图实例";
    }

    this.map = mapC;
    this.clickCallBack = eventConfigPar.clickEvent || "";

    /*处理个性化配置*/
    if (typeof (optionsC) === "object" && !(optionsC instanceof Array)) {
      this.options = Object.assign({}, this.options, optionsC);/*将传入的配置属性值覆盖默认值*/
    } else {
      console.log("options参数格式错误");
    }

    this.addXiazuanLayer();/*添加下钻所需图层*/
    this.mapOn();/*绑定下钻图层事件*/

    if (this.options.init_hilight) {
      this.do_init_hilight()
    }
  }

  /*初始化高亮*/
  do_init_hilight(_qhdm) {
    /*初始高亮区划代码*/
    let qhdm = _qhdm || this.options.init_hilight_qhdm
    if (qhdm) {
      let level_name = ''
      if (qhdm.length == 2) {
        level_name = '省'
      } else if (qhdm.length == 4) {
        level_name = '地市'
      } else if (qhdm.length == 6) {
        level_name = '县'
      }

      let layerObj = xiazuanConfig.xzqLayer.find(item => {
        return item.levelName == level_name
      });

      if (layerObj) {
        that.hilightBorder(qhdm, layerObj);
      }
    }
  }

  inActive(options_o = {}) {
    let options = {
      /*是否清除高亮*/
      remove_hilight: true
    }

    Object.assign(options, options_o);/*将传入的配置属性值覆盖默认值*/

    let map = options_o.map || this.map

    try {
      /*解除事件*/
      xiazuanConfig.xzqLayer.forEach(item => {
        if (map.getLayer(item.layer_fill)) {
          map.off("mousemove", item.layer_fill, this.Mousemove);
          map.off("mouseout", item.layer_fill, this.Mouseout);
          map.off("click", item.layer_fill, this.xiazuanLayerClick);
        }
      });

      /*清除下钻添加的图层*/
      this.addLayerIds.forEach(item => {

        if (!options.remove_hilight && item == that.options.drill_down_sys_hilight_bk) {
          return
        }

        if (this.map.getLayer(item)) {
          this.map.removeLayer(item);
        }
      });
    } catch (e) {

    }

    /*重置下钻参数*/
    this.addLayerIds = [];
    this.options = {
      init_hilight: true,/*是否初始化高亮*/
      init_hilight_qhdm: '',
      drill_down_sys_hilight_bk: "sys_hilight_layerId",
      last_click_query_features: "",/*上次下钻查询的下级features*/
      last_click_e: "",/*上次下钻点击图层返回的参数*/
      ifHlightBorder: true, /*是否高亮边框*/
      xiazuanToLevel: "", /*配置下钻的最低级别,比如村级不需要下钻,这里就配置为村的level数*/
      cyXizauanZoomLevel: 13.1, /*点击村域,下钻后的级别,如点击村域下钻后需要显示地块,则此处可设置地块的minZoom保证地块能显示,默认13.1,如传"fit",则定位以显示村范围为主*/
      cyFitMaxZoom: "",/*点击村域下钻为fit时,设置最大放大级别*/
      cyFitPadding: "",/*点击村域下钻为fit时,设置padding*/
      limit_qhdm: "",
      cur_over_qhdm: "",
    };
    this.clickCallBack = "";
    this.map = ''
  }

  /*执行最近一次下钻的定位和高亮*/
  re_do() {
    if (!that.last_click_e) {
      return
    }
    that.xiazuanLayerClick(that.last_click_e, that.last_click_query_features);
  }

  /**
   * 下钻图层点击事件
   * @param e
   * @constructor
   * @param next_level_features 下级图层查询的features
   */
  xiazuanLayerClick(e, next_level_features = "") {

    let layerId = e.features[0].layer.id;
    /*获取当前点击的基本的行政区的信息对象*/
    let layerObj = xiazuanConfig.xzqLayer.find((item) => {
      return (item.layer_fill === layerId) ? item : null;
    });

    let qhdm = e.features[0].properties['qhdm'];
    let qhmc = e.features[0].properties['qhmc'];


    /*其他省不响应*/
    if (that.options.limit_qhdm && !qhdm.startsWith(that.options.limit_qhdm)) {
      return
    }

    that.last_click_e = {features: e.features, lngLat: e.lngLat}

    /*如果配置的是下钻并高亮边框*/
    if (that.options.ifHlightBorder) {
      that.hilightBorder(qhdm, layerObj);
    }

    let lv = layerObj.level;

    /*获取下一级别行政区的信息对象*/
    let nextLayerObj = xiazuanConfig.xzqLayer.find(function (item) {
      return (item.level === (lv + 1)) ? item : null;
    });


    /*执行下钻点击的回调函数*/
    if (that.clickCallBack) {
      that.clickCallBack({qhdm, qhmc}, e, layerObj, nextLayerObj);
    }

    /*定位*/
    let qh_features = next_level_features || that.map.querySourceFeatures(e.features[0].layer.source, {
      'sourceLayer': e.features[0].layer.source,
      'filter': ['==', 'qhdm', qhdm]
    });

    that.last_click_query_features = qh_features

    let featureCollection = turf.featureCollection(qh_features);
    let center = turf.center(featureCollection).geometry.coordinates;
    let bbox = turf.bbox(featureCollection);

    let e_bound = turf.bbox(e.features[0].geometry);
    let bounds = new mapboxgl.LngLatBounds(new mapboxgl.LngLat(e_bound[0], e_bound[1]), new mapboxgl.LngLat(e_bound[2], e_bound[3]));
    /*点击村用fitBounds定位,其余用Center加Zoom组合定位保证能定位到下一行政区的级别*/
    if (layerObj.levelName != "村") {

      if(lv == 4){
        /*that.map.setCenter(center)
        that.map.setZoom(layerObj.maxzoom + 0.1)*/

        that.map.flyTo({
          center: center,
          zoom: layerObj.maxzoom + 0.5,
          speed: 1,
        })

      }else{
        that.map.fitBounds(bbox, {
          padding: 100,
          maxZoom: nextLayerObj.maxzoom - 0.3
        });
      }



     /* setTimeout(() => {

        if(that.map.getZoom() < layerObj.maxzoom ){
          that.map.setZoom(layerObj.maxzoom + 0.1)
        }


      },600)*/

      /*  that.map.flyTo({
          center: center,
          zoom: nextLayerObj.minzoom + 0.1,
          speed: 1,
        });*/
    } else {
      if (that.options.cyXizauanZoomLevel != "fit") {
        that.map.setCenter(bounds.getCenter());
        that.map.zoomTo(that.options.cyXizauanZoomLevel);
      } else {
        let filter = {padding: 50};
        if (that.options.cyFitPadding) {
          filter.padding = parseFloat(that.options.cyFitPadding);
        }
        if (that.options.cyFitMaxZoom) {
          filter.maxZoom = parseFloat(that.options.cyFitMaxZoom);
        }
        that.map.fitBounds(bbox, filter);
      }

    }
  }

  /**
   * 鼠标移动事件
   * @param e
   * @constructor
   */

  /*Mousemove(e) {
    if (e && e.features[0]) {
      let layerId = e.features[0].layer.id;
      let layerObj = xiazuanConfig.xzqLayer.find(function (ele) {
        return (ele.layer_fill === layerId) ? ele : null;
      });
      if (layerObj) {
        let qhdm = e.features[0].properties[layerObj.qhdm_props]


        if(that.options.limit_qhdm){
          /!*其他省不做响应*!/
          if(qhdm.startsWith(that.options.limit_qhdm)){
            let opacity = parseFloat(layerObj.overFillOpacity) || xiazuanConfig.defaultOverFillOpacity || 0.2
            that.map.setPaintProperty(layerId,"fill-opacity",['case',['==',['get',layerObj.qhdm_props],qhdm],opacity,0],)
          }else{
            that.map.setPaintProperty(layerId,"fill-opacity",0)
          }
        }else{
          let opacity = parseFloat(layerObj.overFillOpacity) || xiazuanConfig.defaultOverFillOpacity || 0.2
          that.map.setPaintProperty(layerId,"fill-opacity",['case',['==',['get',layerObj.qhdm_props],qhdm],opacity,0],)
        }
      }
    }
  }*/

  Mousemove(e) {
    if (e && e.features[0]) {
      let layerId = e.features[0].layer.id;
      let qhdm = e.features[0].properties['qhdm']
      if (that.options.limit_qhdm) {
        /*其他省不做响应*/
        if (qhdm.startsWith(that.options.limit_qhdm)) {
          if(qhdm != that.options.cur_over_qhdm){
            that.options.cur_over_qhdm = qhdm
            that.map.setPaintProperty(layerId, "fill-opacity", ['case', ['==', ['get', 'qhdm'], qhdm], 0.2, 0],)
          }
        } else {
          if(that.map.getPaintProperty(layerId,"fill-opacity") != 0){
            that.map.setPaintProperty(layerId, "fill-opacity", 0)
          }
        }
      } else {
        that.map.setPaintProperty(layerId, "fill-opacity", ['case', ['==', ['get', 'qhdm'], qhdm], 0.2, 0],)
      }

    }
  }

  /**
   * 鼠标移出事件
   * @param e
   * @constructor
   */
/*  Mouseout(e) {
    xiazuanConfig.xzqLayer.forEach(item => {
      if (that.map.getLayer(item.layer_fill)) {
        that.map.setPaintProperty(item.layer_fill, "fill-opacity", 0)
      }
    });
  };*/

  Mouseout(e) {
   /* if (e && e.features[0]) {
      let layerId = e.features[0].layer.id;
      that.map.setPaintProperty(layerId.layer_fill, "fill-opacity", 0)
    }*/
  };

  /**
   * 计算当前行政区级别的配置信息
   */
  getCurrentLevelObj() {
    let curZoom = this.map.getZoom();
    let currentLevelObj = xiazuanConfig.xzqLayer.find(function (item) {//根据当前行政级别取查找对应的行政区级别的资源
      return (item.minzoom < curZoom && item.maxzoom >= curZoom);
    });
    return currentLevelObj;
  }


  /**
   * 高亮行政区边框
   * @param areaCode 区划代码
   */
  hilightBorder(areaCode, curxzq) {
    /*如果已经有高亮图层，并且过滤区划代码是当前代码，则显示图层即可*/
    let map = this.map;
    let hilight_layer = map.getLayer(that.options.drill_down_sys_hilight_bk)
    if (hilight_layer && hilight_layer.filter && hilight_layer.filter[2] == areaCode) {
      map.setLayoutProperty(that.options.drill_down_sys_hilight_bk, 'visibility', 'visible')
      return
    }

    if (map.getLayer(that.options.drill_down_sys_hilight_bk)) {
      map.removeLayer(that.options.drill_down_sys_hilight_bk);
    }
    setTimeout(() => {
      if (!this.map.getLayer(that.options.drill_down_sys_hilight_bk)) {
        this.map.addLayer({
          "id": that.options.drill_down_sys_hilight_bk,
          "type": "line",
          "source": curxzq.sourceId,
          "source-layer": curxzq.sourceLayer,
          "minzoom": curxzq.minzoom,
          "layout": {
            "visibility": "visible"
          },
          "paint": {
            "line-color": curxzq.borderColor || xiazuanConfig.defaultBorderColor || "#54B7F5",
            "line-opacity": parseFloat(curxzq.borderOpacity) || parseFloat(xiazuanConfig.defaultBorderOpacity) || 1,
            "line-width": parseFloat(curxzq.borderWidth) || parseFloat(xiazuanConfig.defaultBorderWidth) || 4,
          },
          "filter": ["==", curxzq.qhdm_props, areaCode]
        });
        if (!this.addLayerIds.includes(that.options.drill_down_sys_hilight_bk)) {
          this.addLayerIds.push(that.options.drill_down_sys_hilight_bk);
        }
      }
    }, 300)
  }

  /**
   *添加下钻所需的图层 (总共三种:
   *                      1.各级别行政区的fill层(透明的),用于查询图层数据;
   *                      2.各级别行政区的fill层,用于鼠标悬浮某行政区后高亮该行政区蒙层;
   *                      3.各级别行政区的line层,用于高亮该行政区的边框
   *                    );
   * @param
   */
  addXiazuanLayer() {
    let minLevel = "";
    if (this.options.xiazuanToLevel) {
      minLevel = this.options.xiazuanToLevel;
    }

    let map = this.map;

    /*遍历地图图层的配置信息来添加相关图层*/
    for (let i = 0; i < xiazuanConfig.xzqLayer.length; i++) {
      let item = xiazuanConfig.xzqLayer[i];
      if (minLevel && item.level === minLevel) {
        break;
      }
      ;

      let temp_layer = map.getLayer(item.layerId)

      //1增加透明的fill图层用于查询
      if (!this.map.getLayer(item.layer_fill)) {
        this.map.addLayer({
          "id": item.layer_fill,
          "type": "fill",
          "source": temp_layer.source,
          "source-layer": temp_layer.sourceLayer,
          "minzoom": item.minzoom,
          "maxzoom": item.maxzoom,
          "layout": {
            "visibility": "visible"
          },
          "paint": {
            "fill-color": item.overFillColor || xiazuanConfig.defaultOverFillColor || "#0127EB",
            "fill-opacity": 0
          },
        });
        this.addLayerIds.push(item.layer_fill);
      }
      ;

      //3增加边界bk图层用于高亮行政区边界
      if (!this.map.getLayer(item.layer_bk)) {
        this.map.addLayer({
          "id": item.layer_bk,
          "type": "line",
          "source": temp_layer.source,
          "source-layer": temp_layer.sourceLayer,
          "minzoom": item.minzoom,
          "maxzoom": item.maxzoom,
          "layout": {
            "visibility": "visible"
          },
          "paint": {
            "line-color": item.borderColor || xiazuanConfig.defaultBorderColor || "#54B7F5",
            //"line-opacity": parseFloat(item.borderOpacity) || parseFloat(xiazuanConfig.defaultBorderOpacity) || 1,
            "line-opacity": 0,
            "line-width": parseFloat(item.borderWidth) || parseFloat(xiazuanConfig.defaultBorderWidth) || 4,
          },
        });
        this.addLayerIds.push(item.layer_bk);
      }
    }
    ;
  }

  /**
   *绑定下钻相关事件
   * @param
   */
  mapOn() {
    xiazuanConfig.xzqLayer.forEach((item, index) => {
      if (this.map.getLayer(item.layer_fill)) {
        /*绑定下钻相关图层事件*/
        this.map.on("mousemove", item.layer_fill, this.Mousemove);//高亮当前鼠标划过的行政区
       // this.map.on("mouseout", item.layer_fill, this.Mouseout);//去掉高亮当前鼠标划过的行政区
        this.map.on("click", item.layer_fill, this.xiazuanLayerClick);//识别图层点击事件
      }
    });
  }

  /**
   * 过滤图层
   * @param layerId
   * @param filter
   */
  setMapFilter(layerId, filter) {
    if (this.map && this.map.getLayer(layerId)) {
      this.map.setFilter(layerId, filter);
    }
  }

  /**
   * 取消当前高亮边框
   */
  moveCurHilight() {
    let bk_hilight_layer_id = that.options.drill_down_sys_hilight_bk
    if (bk_hilight_layer_id && this.map.getLayer(bk_hilight_layer_id)) {
      this.setMapFilter(bk_hilight_layer_id, ["==", "qhdm", "jiazhi"]);
    }
  }

}


export default drillDown;



// WEBPACK FOOTER //
// ./src/assets/js/drillDown/drillDown.js